module.exports = __webpack_public_path__ + "static/media/corporate-services-img93.13cb6652.jpg";